/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */

/**
 * The transaction status
 * @nullable
 */
export type AccountTransactionStatus =
  | (typeof AccountTransactionStatus)[keyof typeof AccountTransactionStatus]
  | null

export const AccountTransactionStatus = {
  All: "All",
  Accepted: "Accepted",
  Authorising: "Authorising",
  Pending: "Pending",
  Rejected: "Rejected",
} as const
